<script setup lang="ts">
import { computed } from 'vue';
const emits = defineEmits(['update:modelValue'])

type keyValue = {
  key: string | number,
  value: string | number
}

const props = withDefaults(
  defineProps<{
    label?: string
    items: any
    modelValue: keyValue
    clearable: boolean
  }>(),
  {
    clearable: true,
    label: '',
  }
)

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})
</script>
<template>
  <v-select
    v-model="modelValue"
    :label="props.label"
    :items="props.items"
    item-value="value"
    item-title="key"
    hide-details="auto"
    class="select-box"
    v-bind="{'return-object': true}"
    :clearable="props.clearable"
  />
</template>
<style scoped>
.select-box {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>